import React from 'react';
import classNames from 'classnames';
import { ExternalLink, NamedLink } from '../../components';
import { searchPageUrls } from './GrabBannerDesktop';
import css from './BundlePromoBanner.css';

// Drive lah x Bundle campaign — "Drive, Earn Tickets, Win" (TECH-4003).
const BUNDLE_HELP_ARTICLE_URL =
  'https://help.drivelah.sg/en/articles/16770404-drive-lah-x-bundle-drive-earn-tickets-win';

const HIGHLIGHTS = [
  'S$128K + Prize Pool',
  '1,000+ customers rewarded',
  'Skip the wait? Get up to S$6',
];

const CheckIcon = () => (
  <span className={css.checkIcon}>
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M3 8.5L6 11.5L13 4.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const BundlePromoBanner = () => {
  return (
    <section className={css.sectionWrapper}>
      <div className={css.container}>
        <div className={css.coupon}>
          <span className={classNames(css.edgeNotch, css.edgeNotchLeft)} />
          <span className={classNames(css.edgeNotch, css.edgeNotchRight)} />

          <div className={css.main}>
            <h2 className={css.title}>
              Your next booking could win you <span className={css.amount}>S$64,050</span>
            </h2>
            <p className={css.description}>
              Book your next car and earn tickets toward a cash draw with 1,000+ winners.
            </p>

            <div className={css.divider}>
              <span className={classNames(css.divNotch, css.divNotchLeft)} />
              <span className={classNames(css.divNotch, css.divNotchRight)} />
            </div>

            <ul className={css.checkList}>
              {HIGHLIGHTS.map(highlight => (
                <li key={highlight} className={css.checkItem}>
                  <CheckIcon />
                  {highlight}
                </li>
              ))}
            </ul>

            <ExternalLink href={BUNDLE_HELP_ARTICLE_URL} className={css.link}>
              See how it works
            </ExternalLink>
          </div>

          <div className={css.stub}>
            <span className={classNames(css.stubNotch, css.stubNotchStart)} />
            <span className={css.stubEyebrow}>Entry closes on</span>
            <span className={css.stubDate}>30th Sept 2026</span>
            <NamedLink name="SearchPage" to={{ search: searchPageUrls() }} className={css.bookNow}>
              Book now
            </NamedLink>
            <span className={classNames(css.stubNotch, css.stubNotchEnd)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BundlePromoBanner;
